import React from 'react';
import Tooltip from 'atomic/tooltip';
import CouponInterface from 'modules/shared/widgets/shared/widget-coupon/widget-coupon.props';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-coupon.scss';

interface WidgetCouponProps {
    coupon: CouponInterface[];
}

const WidgetCoupon: React.FC<WidgetCouponProps> = ({ coupon }) => {
    return (
        <div className="info">
            { coupon?.map((item) => (
                <>
                    {item.text && (
                        <div className="info__item">
                            {item.type === 'title' && (
                                <div className="info__item--title" style={{ color: item.color }}>
                                    {item.text}
                                </div>
                            )}
                            {item.type === 'description' && (
                                <div
                                    className="info__item--description" style={{ color: item.color }}
                                    dangerouslySetInnerHTML={{ __html: item.text.replace('\n', '<br>') }}
                                />
                            )}
                            {item.type === 'coupon' && (
                                <div onClick={(): Promise<void> => navigator.clipboard.writeText(item.text)}>
                                    <Tooltip
                                        positions={['top']}
                                        trigger={<button
                                            className="info__item--coupon"
                                            title="Kliknij, aby skopiować kupon"
                                            style={{ color: item.color, background: item.background, borderColor: item.color }}
                                        >
                                            <span>{item.text}</span>
                                        </button>}
                                        title={<>Skopiowano kod rabatowy</>}
                                    />
                                </div>
                            )}
                            {item.type === 'cta' && (
                                <a className="info__item--cta"
                                    style={{ color: item.color, background: item.background }}
                                    href={item.link}
                                    target={item.target}
                                    rel={getLinkRelByTarget(item.target)}
                                >
                                    {item.text}
                                </a>
                            )}
                        </div>
                    )}
                </>
            ))}
        </div>
    );
};

export default WidgetCoupon;
